<template>
    <div style="margin-top: 20px">
        <div style="padding-left: 30px; padding-right: 30px" class="text-area-note">
            <label>メモ</label>
            <el-input type="textarea" length="256" rows="5" v-model="note" v-bind:readonly="!editable"></el-input>
        </div>
        <div class="btn-note" v-if="editable">
            <el-button v-bind:class="['btn button-color', gtm_class]" :disabled="!has_note && note.length === 0" @click="saveNote"><span v-bind:class="gtm_class">メモを保存</span>
            </el-button>
        </div>
    </div>
</template>

<script>
    import memberNoteMixin from '../../mixins/memberNoteMixin'

    export default {
        name: 'MemberNote',
        mixins: [memberNoteMixin],
        props: {
            gtm_class: String,
            id: {
                type: String,
                default: ''
            },
            type: String,
            editable: {
                type: Boolean,
                default: true
            }
        },
        created () {
            if (this.id === '') {
                this.getMemberNote(this.type)
            } else {
                this.getMemberNoteById(this.id, this.type)
            }
        },
        methods: {
            saveNote () {
                this.saveMemberNote({ 'note': this.note.trim(), 'type': this.type })
            }
        }
    }
</script>

<style scoped>
    .btn-note {
        text-align: center;
        margin-top: 20px;
    }

    .text-area-note >>> .el-textarea .el-textarea__inner {
        border: 1px solid #c0b283;
        font-size: 14px;
        padding-left: 1em;
        width: 100%;
    }
</style>
